import React from "react";
import { LoginForm } from "../components/Forms";

const Login = () => {
  return (
    <section className="section">
      <LoginForm />
    </section>
  );
};

export default Login;
